import React from 'react';
import { omit } from 'lodash';
import LinearProgress from '@material-ui/core/LinearProgress';
import Button from '@material-ui/core/Button';
import { string, bool } from 'prop-types';

import styles from './styles/index';

const ProgressButton = (props = {}) => {
  const { loading, label, primary } = props;

  return (
    <Button
      color={primary ? 'primary' : 'default'}
      {...omit(props, ['loading', 'primary', 'label'])}
    >
      {loading && <LinearProgress className={styles['progressButton--icon']} />}
      {label}
    </Button>
  );
};

ProgressButton.propTypes = {
  loading: bool,
  label: string,
  primary: bool
};

export default ProgressButton;



// WEBPACK FOOTER //
// ./src/client/shared-components/ProgressButton/index.js